import { get } from 'lodash';
import * as React from 'react';
import { format } from 'date-fns';
import { Prompt } from 'react-router';
import { reduxForm } from 'redux-form';
import { Card } from 'material-ui/Card';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { compose, withHandlers, withProps, withState } from 'recompose';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import * as uuid from 'uuid/v4';

import { entityDetailEnhancer } from '@components/hoc/entityDetailEnhancer';

import { TicketsFormBasic } from '@modules/tickets/TicketsFormBasic';
import { getTicket, putTicket } from '@modules/tickets/_ticketsActions';
import * as T from '@modules/tickets/_ticketsTypes';
import { ModalButton } from '@components/modalButton/ModalButton';
import { EventsFormDelictsBNPPaymentForm } from '@modules/events/EventsFormDelictsBNPPaymentForm';
import { withNotifications } from '@components/hoc/withNotifications';
import { Loader } from '@components/loader';

const enhance = compose<T.TicketsFormProps, T.Outter & T.TicketsFormProps>(
  entityDetailEnhancer<T.TicketEnhancerProps<T.Ticket>, T.Ticket>({
    getEntity: getTicket,
    defaultEntity: {}
  }),
  withState<{}, boolean, string, string>('loader', 'handleLoader', false),
  withNotifications({ putTicket }),
  breadcrumbs(({ entity }) => [{ label: 'Bloky', to: '/tickets' }, { label: get(entity, 'name', 'Nový blok') }]),
  withProps(({ entity }) => ({
    initialValues: {
      ...entity
    },
    maxYear: format(new Date(), 'YYYY'),
    showBnpPay: get(entity, 'state') === 'USED_BNP',
    ticketId: get(entity, 'id'),
    reloadDelict: () => window.location.reload(),
    entity
  })),
  withHandlers({
    onSubmit: ({ putTicketNotify, closeItem, handleLoader }) => async formData => {
      if (handleLoader) {
        handleLoader(true);
      }
      const body = { id: formData.id ? formData.id : uuid(), ...formData };
      const ticket = await putTicketNotify(body);
      if (handleLoader) {
        handleLoader(false);
      }
      if (ticket) {
        closeItem();
      }
    }
  }),
  reduxForm({
    form: 'module-tickets'
  })
);

const View: React.SFC<
  T.Outter & T.TicketsFormProps & { showBnpPay: boolean; ticketId: string; reloadDelict: any; loader: boolean }
> = ({ showBnpPay, ticketId, reloadDelict, entity, loader, ...props }) => (
  <div>
    <Prompt
      when={props.dirty && !props.submitSucceeded && !props.submitting}
      message="Vaše změny nebyly uloženy, přesto odejít?"
    />
    {loader && <Loader />}
    <form className="layout" onSubmit={props.handleSubmit}>
      <Card>
        <TicketsFormBasic entity={entity} />
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>
            <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px' }} />
            <Button label="Zpět" style={{ margin: '16px' }} onClick={props.closeItem} />
          </div>
          {showBnpPay && (
            <ModalButton
              label="Vyřešit BNP"
              style={{ margin: '16px' }}
              ticketId={ticketId}
              reloadDelict={reloadDelict}
              ModalComponent={EventsFormDelictsBNPPaymentForm}
            />
          )}
        </div>
      </Card>
    </form>
  </div>
);

export const TicketsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/tickets/TicketsForm.tsx